var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"dense":"","top":"","right":"","color":_vm.type},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm._value = false}}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }